
    import {Component, Prop, Vue} from 'vue-property-decorator';
    import {Question} from '@/lib/Question';
    import SuggestionChoices from './SuggestionChoices.vue';

    @Component({
        components: {
            SuggestionChoices
        }
    })
    export default class TextQuestion extends Vue {
        @Prop() public question: Question;
        public updateWithSuggestion(choice) {
            this.question!.currentResponse!.value = choice.value;
            this.question.changedEvent.emit('');
            this.question.validate();
            setTimeout(() => {
                this.$emit('chosen');
            }, 500);
        }
    }
